// extracted by mini-css-extract-plugin
export var closeButton = "_fb-2";
export var closeButtonIcon = "_fb-3";
export var lightboxContent = "_fb-1";
export var lightboxOverlay = "_fb-0";